import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import client from "./client";
import API_ENDPOINTS from "../constants/api-endpoints";
import { TPushNotificationToken, TPushTokenStats } from "../types";

type Callbacks = { onSuccess?: (res: any) => void; onError?: (err: any) => void };

export type PushTokenListParams = {
  company_id?: number | string;
  user_id?: number | string;
  platform?: string;
  is_active?: string;
  page?: number;
  limit?: number;
};

export const usePushTokens = (params: PushTokenListParams = {}) => {
  return useQuery({
    queryKey: [API_ENDPOINTS.PUSH_TOKENS, params],
    queryFn: () => client.get(API_ENDPOINTS.PUSH_TOKENS, { params }),
    select: (res: any) => ({
      data: res.data.data as TPushNotificationToken[],
      total: res.data.extra?.total ?? 0,
      page: res.data.extra?.page ?? 1,
      limit: res.data.extra?.limit ?? 50,
    }),
    refetchOnWindowFocus: false,
  });
};

export const usePushTokenStats = () => {
  return useQuery({
    queryKey: [API_ENDPOINTS.PUSH_TOKEN_STATS],
    queryFn: () => client.get(API_ENDPOINTS.PUSH_TOKEN_STATS),
    select: (res: any) => res.data.data as TPushTokenStats,
    refetchOnWindowFocus: false,
  });
};

export const usePushTokenDeactivate = ({ onSuccess, onError }: Callbacks = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => client.delete(API_ENDPOINTS.PUSH_TOKEN_DEACTIVATE(id)),
    onSuccess: (res) => {
      queryClient.invalidateQueries({ queryKey: [API_ENDPOINTS.PUSH_TOKENS] });
      queryClient.invalidateQueries({ queryKey: [API_ENDPOINTS.PUSH_TOKEN_STATS] });
      onSuccess?.(res);
    },
    onError: (err) => onError?.(err),
  });
};
